module.exports = __webpack_public_path__ + "static/media/fireplace2.4d03521c.png";